<template>
  <div class="relative sm:mx-[-30px] lg:mx-0 lg:max-w-full">
    <div class="overflow-x-auto lg:overflow-visible">
      <table class="table w-[800px] table-auto sm:w-full">
        <thead>
          <tr class="relative">
            <th
              v-for="(column, index) in columns"
              :key="index"
              class="bg-gpx_gray-900 py-[12px] text-left sm:py-0 lg:first-of-type:rounded-tl-[6px]"
              :class="{ 'lg:last-of-type:rounded-tr-[6px]': !hasEdit }"
            >
              <div
                class="relative whitespace-nowrap pr-[40px] text-left text-label text-gpx_label font-semibold uppercase leading-8 text-gpx_gray-300 transition-colors duration-200 sm:my-[12px]"
                :class="[
                  { 'pl-[24px] sm:pl-[32px]': index === 0 },
                  {
                    'cursor-pointer hover:text-gpx_porto-400': column.filterable
                  },
                  { 'text-gpx_porto-400': filterColumn === index }
                ]"
              >
                <span>{{ column }}</span>
                <ChevronUpDownIcon
                  class="heroicon-stroke-w-1.4 h-[16px] w-[16px] text-gpx_gray-200"
                  v-if="column.filterable && filterColumn !== index"
                />
                <ChevronDownIcon
                  class="heroicon-stroke-w-1.4 mx-[2px] h-[12px] w-[12px] text-gpx_porto-500"
                  v-if="column.filterable && filterColumn === index && filterOrder === 'DESC'"
                />
                <ChevronUpIcon
                  class="heroicon-stroke-w-1.4 mx-[2px] h-[12px] w-[12px] text-gpx_porto-500"
                  v-if="column.filterable && filterColumn === index && filterOrder === 'ASC'"
                />
              </div>
            </th>
            <!-- Edit -->
            <th class="bg-gpx_gray-900 py-0 pl-0 lg:last-of-type:rounded-tr-[6px]"></th>
            <!-- // Edit -->
          </tr>
        </thead>
        <tbody
          class="relative before:absolute before:right-0 before:top-0 before:h-full before:border-l before:border-l-gpx_gray-800 after:absolute after:left-0 after:top-0 after:h-full after:border-l after:border-l-gpx_gray-800"
        >
          <DataTableItem
            v-for="(item, index) in list"
            :data="item"
            :key="index"
            :truncate="truncate"
            :mode="mode"
            :route="{ name: routeName, params: { id: item.id } }"
            :editActions="editActions"
            :editItemId="editItemId"
            @setEditItemId="setEditItemId"
            @click="$emit('itemClick', item)"
            class="group"
          />
        </tbody>
      </table>
    </div>
    <div v-if="loading" class="z-30 flex h-full w-full items-center justify-center">
      <Spinner size="lg" class="absolute top-0 pt-[56px]"/>
    </div>
  </div>
</template>

<script>
import { ChevronUpDownIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/24/outline'
import DataTableItem from './DataTableItem.vue'
import Spinner from "./Spinner.vue";

export default {
  name: 'DataTable',
  components: {
    Spinner,
    DataTableItem,
    ChevronUpDownIcon,
    ChevronDownIcon,
    ChevronUpIcon
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      required: true
    },
    truncate: {
      type: Array,
      required: false
    },
    list: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      validator(value) {
        return ['static', 'link', 'callback'].includes(value)
      },
      default: 'static'
    },
    routeName: {
      type: String,
      required: false
    },
    editActions: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      editItemId: null,
      filterColumn: null,
      filterOrder: 'DESC'
    }
  },
  computed: {
    hasEdit() {
      return this.list[0]?.['edit'] === true
    }
  },
  methods: {
    setFilterColumn(index) {
      if (this.filterColumn !== index) {
        this.filterReset()
        this.filterColumn = index
        return
      }
      if (this.filterOrder === 'DESC') {
        this.filterOrder = 'ASC'
        return
      }
      if (this.filterOrder === 'ASC') {
        this.filterReset()
        return
      }
      this.filterColumn = index
    },
    filterReset() {
      this.filterOrder = 'DESC'
      this.filterColumn = null
    },
    setEditItemId(id) {
      this.editItemId = id
    }
  }
}
</script>
